import React, { useEffect, useState } from 'react';
import {
  filterSelector,
  filterColorSelector,
  breadcrumbSelector,
} from '@store/overviewDashboard/base/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { getFilters } from '@store/filterContainer/actions';
import SummaryBreadcrumb from '@components/summary-panel/SummaryContainer/SummaryBreadcrumb';
import { popBreadcrumb } from '@store/overviewDashboard/base/actions';
import { EllipsisTooltip } from '@components/common';
import { useInvalidDimensionCheck } from '@src/utils/filter/useInvalidDimensionCheck';
import FilterPopup from './FilterPopup';
import {
  ModalMask,
  FilterWrapper,
  FilterLabelWrapper,
  FilterTitleWrapper,
  FilterTitle,
  StyledHeader,
  VerticalBar,
  BreadcrumbWrapper,
} from './styled';

function FilterContainer() {
  const dispatch = useDispatch();

  const [visible, setVisible] = useState(false);
  const appliedFilter = useSelector(filterSelector);
  const filterColor = useSelector(filterColorSelector);
  const breadcrumb = useSelector(breadcrumbSelector);

  const invalidDimensionWarning = useInvalidDimensionCheck()(appliedFilter.rule, {
    style: {
      position: 'absolute',
      top: '50%',
      right: '-24px',
      transform: 'translateY(-50%)',
      fontSize: 18,
    },
  });

  const showFilterPopup = () => setVisible(true);
  const hideFilterPopup = () => setVisible(false);

  const applyFilterFromBreadcrumb = (index) => {
    dispatch(popBreadcrumb(breadcrumb, index));
  };

  useEffect(() => {
    dispatch(getFilters());
  }, []);

  return (
    <FilterLabelWrapper>
      <StyledHeader>
        <FilterTitleWrapper onClick={showFilterPopup}>
          <VerticalBar filterColor={filterColor} />
          <FilterTitle>
            <EllipsisTooltip text={appliedFilter.name} />
          </FilterTitle>
          {invalidDimensionWarning}
        </FilterTitleWrapper>
        <BreadcrumbWrapper>
          <SummaryBreadcrumb
            drilldown={breadcrumb}
            applyFilterFromBreadcrumb={applyFilterFromBreadcrumb}
          />
        </BreadcrumbWrapper>
      </StyledHeader>

      {visible ? (
        <>
          <ModalMask onClick={hideFilterPopup} />
          <FilterWrapper id="filter-popup">
            <FilterPopup onCancel={hideFilterPopup} appliedFilter={appliedFilter} />
          </FilterWrapper>
        </>
      ) : null}
    </FilterLabelWrapper>
  );
}

export default FilterContainer;
